import React from 'react';
import {Redirect} from 'react-router-dom';

class Button extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
		this.state = { navigate : false };
	}

	onClick(e) {
		e.preventDefault();

		if (this.props.onClick) {
			this.props.onClick();
		}
		else if(this.props.redirect) {
			this.setState({navigate : true});
		}
	}

	render() {
		const nav = this.state.navigate;
		const dataId = this.props.dataId || '';
		if (nav) {
			return (
				<Redirect to={this.props.redirect} push={true} />
				);
		}
		return (

			<button className={this.props.class} dataid={dataId} onClick={this.onClick} >{this.props.label}</button>

			);
	}
}

class SmallLink extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		e.preventDefault();
		this.props.onClick();
	}

	render() {
		return (

			<p onClick={this.onClick} className={this.props.class + " App-SmallLink"}>{this.props.label}</p>

			);
	}
}

class ContainerArrowButton extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		const key = e.currentTarget.getAttribute('data-id');

		if(typeof this.props.onClick === 'function') {
			this.props.onClick(key);
		}

	}

	render() {

		return (
			<button className={this.props.class} onClick={this.onClick} style={{float: "right"}}><img src="/images/white-arrow@2x.png" alt="Button To Subsection" /></button>
		);
	}
}






export {Button, SmallLink, ContainerArrowButton};




